module.exports = __webpack_public_path__ + "img/marker.397824a4.png";